
export function isCodeValid(input: string): boolean {
	const regex = new RegExp(codePattern);
	return regex.test(input);
}

export const codePattern = "^.{8}$";